import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    modalId: String
  }

  connect() {
    // Listen for successful form submission
    this.element.addEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    // Check if the submission was successful (2xx status code)
    if (event.detail.success) {
      this.closeModal()
    }
  }

  closeModal() {
    const modalElement = document.getElementById(this.modalIdValue)
    if (modalElement) {
      // Try to get Bootstrap modal instance (Bootstrap 5)
      let modalInstance = null
      
      if (window.bootstrap && window.bootstrap.Modal) {
        modalInstance = window.bootstrap.Modal.getInstance(modalElement)
      }
      
      if (modalInstance) {
        modalInstance.hide()
      } else {
        // Fallback: trigger close button click
        const closeButton = modalElement.querySelector('[data-bs-dismiss="modal"]')
        if (closeButton) {
          closeButton.click()
        }
      }
    }
  }
}

